import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-appointment-pill',
    templateUrl: './appointment-pill.component.html',
    styleUrls: ['./appointment-pill.component.scss'],
    standalone: false
})
export class AppointmentPillComponent {
    @Input() icon: string;
    @Input() showButtons = false;
    @Output() decrease = new EventEmitter();
    @Output() increase = new EventEmitter();

    constructor() { }

    handleIncrease(): void {
        this.increase.emit();
    }

    handleDecrease(): void {
        this.decrease.emit();
    }
}
